import { ActionButtonType } from "@octopusdeploy/design-system-components";
import * as React from "react";
import { Action, Plan, useAnalyticActionDispatch } from "~/analytics/Analytics";
import { AuditActionWithStatus } from "~/areas/configuration/components/AuditLayout/AuditStream/AuditActionWithStatus";
import { AuditStreamUpsellDialog } from "~/areas/configuration/components/AuditLayout/AuditStream/AuditStreamUpsellDialog";
import OpenDialogButton from "~/components/Dialog/OpenDialogButton";
export function AuditStreamUpsellButton() {
    const dispatchAction = useAnalyticActionDispatch();
    const handleClick = () => {
        dispatchAction("Stream Audit Log", { resource: "Audit Stream", action: Action.Add, plan: Plan.NonEnterprise });
    };
    return (<AuditActionWithStatus status={"inactive"}>
            <OpenDialogButton type={ActionButtonType.Ternary} label="Stream audit log" wideDialog={true} onClick={handleClick} renderDialog={(renderProps) => <AuditStreamUpsellDialog open={renderProps.open} close={() => renderProps.closeDialog()}/>}/>
        </AuditActionWithStatus>);
}
